import { AgmCoreModule } from "@agm/core";
import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { NgInviewModule } from "angular-inport";
import { AppComponent } from "./app.component";
import { DirectivesModule } from "./directives/directives.module";
import { PartialsModule } from "./partials/partials.module";
import { RoutingModule } from "./routing.module";
import { ServicesModule } from "./services/services.module";
import { UiLibraryModule } from "./ui-library/ui-library.module";
import { ContactComponent } from "./views/contact/contact.view.component";
import { HomeComponent } from "./views/home/home.view.component";
import { ImageCanvasComponent } from "./views/home/image-canvas/image-canvas.view.component";
import { NomadComponent } from "./views/nomad/nomad.view.component";
import { NotFoundComponent } from "./views/notfound/notfound.view.component";
import { InProgressComponent } from "./views/inprogress/inprogress.view.component";

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AppComponent,
    ContactComponent,
    HomeComponent,
    NotFoundComponent,
    InProgressComponent,
    ImageCanvasComponent,
    NomadComponent,
  ],
  imports: [
    BrowserModule,
    NgInviewModule,
    PartialsModule,
    RoutingModule,
    UiLibraryModule,
    ServicesModule,
    DirectivesModule,
    AgmCoreModule.forRoot({
      apiKey: "AIzaSyAgIEmRDEn7k4d2GMNaRycEWEeOs01O7QM",
    }),
  ],
  providers: [],
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts